window.__WWAI__ = window.__WWAI__ || {};
  
// Environment + Mode Config
// Use metafield-based subscription in sandbox/local
window.__WWAI__.useMockSubscription = false;

// Options: "local" | "sandbox" | "prod"
window.__WWAI__.deployMode = "prod";

// Enables dev/debugger mode, values are dev, prod
window.__WWAI__.MODE = "prod";

// Controls Liquid-product rendering
window.__WWAI__.RENDER_WITH_LIQUID = true;

// Which connector to use for hydration
window.__WWAI__.CONNECTOR_TYPE = "shopify";

// Enable logging for grid height debugging
window.__WWAI__.heightEqualizeLogging = true;

// Currency Config
// Active currency from Shopify
window.__WWAI__.CURRENCY = Shopify.currency.active;

// Currency conversion factor
window.__WWAI__.CURRENCY_FACTOR = 0.01;

// Product mapping object
window.__WWAI__.JS_PRODUCT_MAPPING_OBJECT = {};

// Product group config
window.__WWAI__.WWAI_PRODUCT_GROUP_CONFIG = {
  "drmtlgy_page_pdp_GUEqaB": {
    "defaults": {
      "pricingConfig": {
        "discountPercent": 20,
        "subscriptionDiscountPercent": 0,
        "defaultSubscriptionOption": null,
        "useVariantCompareAtPriceForSubscription": true,
        "discountCodeToApply": ["TINT20"],
        "roundDiscount": true,
        "addOffSuffixToDiscount": false
      },
      "uxConfig": {
        "variantOptionRemovePrefix": "Every",
        "defaultPurchaseType": "onetime",
        "imageCarouselConfig": {
          "useCustomImages": false
        },
        "variantUXConfig": {
          "hideSingleLengthVariants": false,
          "onlyShowVariantsWithLabelContains": null,
          "refreshUxOnVariantChange": true
        },
        "preAddToCartFlowConfig": {
          "journeyType": "overlay",
          "overlayContents": [],
          "postSelectionAction": "na",
          "postSelectionActionParams": {
            "custom_url": null,
            "redirect_variant_options": null
          }
        }
      },
      "flowConfig": {
        "destination": "cart",
        "loader": "add-to-cart-submit-button",
        "showSuccessNotification": false,
        "showErrorNotification": false,
        "sideCartLabel": "",
        "successNotificationMessage": "✅ Added to cart!",
        "errorNotificationMessage": "Oops, couldn't add item.",
        "notificationOptions": {
          "backgroundColor": "#E8DDFA",
          "textColor": "#000000",
          "borderColor": "transparent",
          "fontFamily": "sans-serif"
        },
        "additionalItemsToAdd": [
          // {
          //   "id": 40192039911479, // Sample Microdermabrasion Scrub
          //   "quantity": 1,
          // },
          // {
          //   "id": 40192040009783, // Sample Makeup Primer
          //   "quantity": 1,
          // },
          // {
          //   "id": 40192040108087, // Sample Barrier Repair Mask
          //   "quantity": 3,
          // }
        ]
      }
    },
    "universal-tinted-moisturizer-spf-46-sticky": {
      "pricingConfig": null,
      "uxConfig": null,
      "flowConfig": null,
      "variantDispatchConfig": {
        "defaultProduct": "universal-tinted-moisturizer-spf-46",
        "defaultVariantOption1": "Default Title",
        "defaultVariantOption2": null,
        "defaultVariantOption3": null,
        "allProducts": "universal-tinted-moisturizer-spf-46",
        "allOptions": {
          "option1": "Default Title",
          "option2": "",
          "option3": ""
        }
      }
    },
    "universal-tinted-moisturizer-spf-46": {
      "pricingConfig": null,
      "uxConfig": null,
      "flowConfig": null,
      "variantDispatchConfig": {
        "defaultProduct": "universal-tinted-moisturizer-spf-46",
        "defaultVariantOption1": "Default Title",
        "defaultVariantOption2": null,
        "defaultVariantOption3": null,
        "allProducts": "universal-tinted-moisturizer-spf-46",
        "allOptions": {
          "option1": "Default Title",
          "option2": "",
          "option3": ""
        }
      }
    }
  },
  "drmtlgy_page_products_grid_fW3kGi": {
    "defaults": {
      "pricingConfig": {
        "discountPercent": 0,
        "subscriptionDiscountPercent": 0,
        "defaultSubscriptionOption": null,
        "useVariantCompareAtPriceForSubscription": true,
        "discountCodeToApply": [],
        "roundDiscount": true,
        "addOffSuffixToDiscount": false
      },
      "uxConfig": {
        "variantOptionRemovePrefix": "Every",
        "defaultPurchaseType": "onetime",
        "imageCarouselConfig": {
          "useCustomImages": false
        },
        "variantUXConfig": {
          "hideSingleLengthVariants": false,
          "onlyShowVariantsWithLabelContains": null,
          "refreshUxOnVariantChange": true
        },
        "preAddToCartFlowConfig": {
          "journeyType": "overlay",
          "overlayContents": [],
          "postSelectionAction": "na",
          "postSelectionActionParams": {
            "custom_url": null,
            "redirect_variant_options": null
          }
        }
      },
      "flowConfig": {
        "destination": "cart",
        "loader": "add-to-cart-submit-button",
        "showSuccessNotification": false,
        "showErrorNotification": false,
        "sideCartLabel": "",
        "successNotificationMessage": "✅ Added to cart!",
        "errorNotificationMessage": "Oops, couldn't add item.",
        "notificationOptions": {
          "backgroundColor": "#E8DDFA",
          "textColor": "#000000",
          "borderColor": "transparent",
          "fontFamily": "sans-serif"
        }
      }
    },
    "matte-universal-tinted-moisturizer-spf-46": {
      "pricingConfig": null,
      "uxConfig": null,
      "flowConfig": null,
      "variantDispatchConfig": {
        "defaultProduct": "matte-universal-tinted-moisturizer-spf-46",
        "defaultVariantOption1": "Default Title",
        "defaultVariantOption2": null,
        "defaultVariantOption3": null,
        "allProducts": "matte-universal-tinted-moisturizer-spf-46",
        "allOptions": {
          "option1": "Default Title",
          "option2": "",
          "option3": ""
        }
      }
    },
    "spf-undereye-corrector-medium": {
      "pricingConfig": null,
      "uxConfig": null,
      "flowConfig": null,
      "variantDispatchConfig": {
        "defaultProduct": "spf-undereye-corrector-medium",
        "defaultVariantOption1": "Default Title",
        "defaultVariantOption2": null,
        "defaultVariantOption3": null,
        "allProducts": "spf-undereye-corrector-medium",
        "allOptions": {
          "option1": "Default Title",
          "option2": "",
          "option3": ""
        }
      }
    },
    "brightening-eye-masks": {
      "pricingConfig": null,
      "uxConfig": null,
      "flowConfig": null,
      "variantDispatchConfig": {
        "defaultProduct": "brightening-eye-masks",
        "defaultVariantOption1": "Default Title",
        "defaultVariantOption2": null,
        "defaultVariantOption3": null,
        "allProducts": "brightening-eye-masks",
        "allOptions": {
          "option1": "Default Title",
          "option2": "",
          "option3": ""
        }
      }
    },
    "lip-silk-spf-40": {
      "pricingConfig": null,
      "uxConfig": null,
      "flowConfig": null,
      "variantDispatchConfig": {
        "defaultProduct": "lip-silk-spf-40",
        "defaultVariantOption1": "Soft",
        "defaultVariantOption2": null,
        "defaultVariantOption3": null,
        "allProducts": "lip-silk-spf-40",
        "allOptions": {
          "option1": "Soft | Bold",
          "option2": "",
          "option3": ""
        }
      }
    },
    "spf-lip-balm": {
      "pricingConfig": null,
      "uxConfig": null,
      "flowConfig": null,
      "variantDispatchConfig": {
        "defaultProduct": "spf-lip-balm",
        "defaultVariantOption1": "Default Title",
        "defaultVariantOption2": null,
        "defaultVariantOption3": null,
        "allProducts": "spf-lip-balm",
        "allOptions": {
          "option1": "Default Title",
          "option2": "",
          "option3": ""
        }
      }
    },
    "c-balm": {
      "pricingConfig": null,
      "uxConfig": null,
      "flowConfig": null,
      "variantDispatchConfig": {
        "defaultProduct": "c-balm",
        "defaultVariantOption1": "Default Title",
        "defaultVariantOption2": null,
        "defaultVariantOption3": null,
        "allProducts": "c-balm",
        "allOptions": {
          "option1": "Default Title",
          "option2": "",
          "option3": ""
        }
      }
    }
  }
};

// Variant overrides
window.__WWAI__.WWAI_PRODUCT_VARIANT_OVERRIDES = {
  "drmtlgy_page_pdp_GUEqaB": {
    "universal-tinted-moisturizer-spf-46-sticky": {
      "universal-tinted-moisturizer-spf-46": {
        "Default Title": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        }
      }
    },
    "universal-tinted-moisturizer-spf-46": {
      "universal-tinted-moisturizer-spf-46": {
        "Default Title": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        }
      }
    }
  },
  "drmtlgy_page_products_grid_fW3kGi": {
    "matte-universal-tinted-moisturizer-spf-46": {
      "matte-universal-tinted-moisturizer-spf-46": {
        "Default Title": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        }
      }
    },
    "spf-undereye-corrector-medium": {
      "spf-undereye-corrector-medium": {
        "Default Title": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        }
      }
    },
    "brightening-eye-masks": {
      "brightening-eye-masks": {
        "Default Title": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        }
      }
    },
    "lip-silk-spf-40": {
      "lip-silk-spf-40": {
        "Soft": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Bold": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        }
      }
    },
    "spf-lip-balm": {
      "spf-lip-balm": {
        "Default Title": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        }
      }
    },
    "c-balm": {
      "c-balm": {
        "Default Title": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        }
      }
    }
  }
};

// Labeled images
window.__WWAI__.WWAI_LABELED_IMAGES = {};

// Action buttons
window.__WWAI__.ACTION_BUTTONS = {};